import { SyntheticEvent, useState } from 'react'
import {
  ActionButton,
  Button,
  DropdownWrapper,
  EditableDropdown,
  FlexWrapper,
  Input,
  Loader,
  PageWrapper,
  SectionTitle
} from '../../../../components'
import strings from '../../../../locale/en'
import { useHistory } from 'react-router'
import DatePicker from 'react-datepicker'
import { leaveTypeList, leaveReasonList, dayStatusList } from './const'
import { DatePickerWrapper } from '../../Institute/subcomponents'
import { LeaveField } from '../typings'
import { validateform } from './helpers'
import { DATE_FORMAT_YYYYMMDD } from '../../../../const/dateFormat'
import { format } from 'date-fns'
import { hasFormError } from '../../../../helpers/formValidation'
import { useDispatch } from 'react-redux'
import { applyLeave } from '../../../../redux/manageLeave/action'
import { Leave } from '../../../../redux/manageLeave/type'

const ApplyLeave = () => {
  const isLoading = false
  const [values, setValues] = useState({} as Leave)
  const [errors, setErrors] = useState({} as Record<string, string>)
  const history = useHistory()
  const dispatch = useDispatch()

  const {
    leaveDetails: {
      selectLeaveType,
      selectReason,
      fromDate,
      toDate,
      selectDayStatus,
      remarks
    },
    menu: {
      leave: { apply: ApplyLeave }
    },
    button: { apply, back }
  } = strings

  const validateField = (field: LeaveField): void => {
    setErrors(
      validateform({
        values,
        errors,
        field
      })
    )
  }

  const handleSubmit = (e: SyntheticEvent) => {
    e.preventDefault()
    const validationError = validateform({
      values,
      errors
    })

    if (hasFormError(validationError)) {
      setErrors(validationError)
    } else {
      const { leaveType, fromDate, toDate, dayStatus, leaveName, remarks } =
        values || {}
      const formData = new FormData()
      formData.append('leaveType', leaveType)
      formData.append('fromDate', fromDate)
      formData.append('toDate', toDate)
      formData.append('dayStatus', dayStatus)
      formData.append('leaveName', leaveName)
      formData.append('remarks', remarks || '')

      dispatch(applyLeave(formData))
    }
  }

  return (
    <PageWrapper id="container">
      <SectionTitle title={ApplyLeave} hasBorder />
      <FlexWrapper justifyContent="space-around">
        <EditableDropdown
          width="30%"
          title={selectLeaveType}
          isRequired
          dropdownList={leaveTypeList}
          handleSelect={(selectedOption) => {
            setValues({ ...values, leaveType: selectedOption.name })
            setErrors(
              validateform({
                values: { ...values, leaveType: selectedOption.name },
                errors,
                field: 'leaveType'
              })
            )
          }}
          onBlur={() => validateField('leaveType')}
          error={errors.leaveType}
          placeholder={selectLeaveType}
        />
        <EditableDropdown
          width="30%"
          title={selectReason}
          isRequired
          dropdownList={leaveReasonList}
          handleSelect={(selectedOption) => {
            setValues({ ...values, leaveName: selectedOption.name })
            setErrors(
              validateform({
                values: { ...values, leaveName: selectedOption.name },
                errors,
                field: 'leaveName'
              })
            )
          }}
          onBlur={() => validateField('leaveName')}
          error={errors.leaveName}
          placeholder={selectReason}
        />
        <DatePickerWrapper>
          <DatePicker
            selected={
              values?.fromDate ? new Date(values?.fromDate) : new Date()
            }
            onSelect={(date: Date) =>
              setValues({
                ...values,
                fromDate: date ? format(date, DATE_FORMAT_YYYYMMDD) : ''
              })
            }
            onChange={(date: Date) =>
              setValues({
                ...values,
                fromDate: date ? format(date, DATE_FORMAT_YYYYMMDD) : ''
              })
            }
            placeholderText={fromDate}
            customInput={
              <Input
                value={values?.fromDate || ''}
                inputType="text"
                label={fromDate}
                placeholder={fromDate}
                suffix={['far', 'calendar']}
              />
            }
          />
        </DatePickerWrapper>
        <DatePickerWrapper>
          <DatePicker
            selected={values?.toDate ? new Date(values?.toDate) : new Date()}
            onSelect={(date: Date) =>
              setValues({
                ...values,
                toDate: date ? format(date, DATE_FORMAT_YYYYMMDD) : ''
              })
            }
            onChange={(date: Date) =>
              setValues({
                ...values,
                toDate: date ? format(date, DATE_FORMAT_YYYYMMDD) : ''
              })
            }
            placeholderText={toDate}
            customInput={
              <Input
                value={values?.toDate || ''}
                inputType="text"
                label={toDate}
                placeholder={toDate}
                suffix={['far', 'calendar']}
              />
            }
          />
        </DatePickerWrapper>
        <EditableDropdown
          width="30%"
          title={selectDayStatus}
          isRequired
          dropdownList={dayStatusList}
          handleSelect={(selectedOption) => {
            setValues({ ...values, dayStatus: selectedOption.name })
            setErrors(
              validateform({
                values: { ...values, dayStatus: selectedOption.name },
                errors,
                field: 'dayStatus'
              })
            )
          }}
          onBlur={() => validateField('dayStatus')}
          error={errors.dayStatus}
          placeholder={selectDayStatus}
        />
        <DropdownWrapper width="33%">
          <Input
            label={remarks}
            value={values?.remarks || ''}
            name={remarks}
            onChange={(value) => {
              setValues({ ...values, remarks: value })
            }}
            hasPadding={false}
            inputType="textarea"
          />
        </DropdownWrapper>
      </FlexWrapper>
      {isLoading ? (
        <Loader />
      ) : (
        <FlexWrapper justifyContent="center">
          <ActionButton
            variant="outline-secondary"
            onClick={() => history.goBack()}
          >
            {back}
          </ActionButton>
          <Button onClick={handleSubmit}>{apply}</Button>
        </FlexWrapper>
      )}
    </PageWrapper>
  )
}

export default ApplyLeave
